import { create } from 'zustand';

export type DownloadMediasNotifierOrder = {
  id: string;
  code: string;
  brandCommercialName: string;
};

interface DownloadMediasNotifierState {
  ordersDownloadingMedias: DownloadMediasNotifierOrder[];
  addOrder: (order: DownloadMediasNotifierOrder) => void;
  removeOrder: (orderId: string) => DownloadMediasNotifierOrder | undefined;
}

export const useDownloadMediasNotifierStore = create<DownloadMediasNotifierState>((set, get) => ({
  ordersDownloadingMedias: [],

  addOrder: (order) => {
    const { ordersDownloadingMedias } = get();
    const existingOrder = ordersDownloadingMedias.find((o) => o.id === order.id);
    if (!existingOrder) {
      set({ ordersDownloadingMedias: [...ordersDownloadingMedias, order] });
    }
  },

  removeOrder: (orderId) => {
    const { ordersDownloadingMedias } = get();
    const orderToRemove = ordersDownloadingMedias.find((o) => o.id === orderId);
    set({
      ordersDownloadingMedias: ordersDownloadingMedias.filter((order) => order.id !== orderId),
    });
    return orderToRemove;
  },
}));

const downloadMediasNotifierStore = {
  get ordersDownloadingMedias() {
    return useDownloadMediasNotifierStore.getState().ordersDownloadingMedias;
  },
  addOrder: (order: DownloadMediasNotifierOrder) =>
    useDownloadMediasNotifierStore.getState().addOrder(order),
  removeOrder: (orderId: string) => useDownloadMediasNotifierStore.getState().removeOrder(orderId),
};

export default downloadMediasNotifierStore;
